export default [
  {
    path: '/search-history/list',
    name: 'search-history-list',
    component: () => import('@/views/search-history/index.vue'),
    meta: {
      pageTitle: 'Search History',
      breadcrumb: [
        { title: 'Dashboard', url: '/' },
        { title: 'Search History', active: true }
      ],
      roles: 'admin',
      allowAnonymous: false
    }
  }
]
